import React, { useState, useEffect } from 'react';
import { DollarSign, TrendingUp, FileSpreadsheet, BookOpen, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FinanceAuth } from '../components/auth/FinanceAuth';
import { isFinanceAuthenticated, setFinanceAuthenticated } from '../lib/auth';

export function Finance() {
  const [isAuthenticated, setIsAuthenticated] = useState(isFinanceAuthenticated());

  const menuItems = [
    {
      title: 'Analysis',
      description: 'View detailed financial analysis, charts, and projections',
      icon: TrendingUp,
      path: '/finance/analysis',
      color: 'bg-indigo-500'
    },
    {
      title: 'QuickBooks',
      description: 'Connect and manage QuickBooks integration',
      icon: BookOpen,
      path: '/finance/quickbooks',
      color: 'bg-emerald-500'
    },
    {
      title: 'XLS',
      description: 'Import and export financial data via spreadsheets',
      icon: FileSpreadsheet,
      path: '/finance/xls',
      color: 'bg-amber-500'
    },
    {
      title: 'DOC',
      description: 'Manage financial documents and reports',
      icon: FileText,
      path: '/finance/doc',
      color: 'bg-blue-500'
    }
  ];

  const handleAuthentication = () => {
    setFinanceAuthenticated(true);
    setIsAuthenticated(true);
  };

  if (!isAuthenticated) {
    return <FinanceAuth onAuthenticate={handleAuthentication} />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center mb-8">
          <DollarSign className="w-8 h-8 text-indigo-600 mr-3" />
          <h1 className="text-3xl font-bold text-gray-900">Financial Management</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems.map((item) => (
            <Link
              key={item.title}
              to={item.path}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-200 hover:scale-105 hover:shadow-xl"
            >
              <div className={`${item.color} p-4`}>
                <item.icon className="w-8 h-8 text-white" />
              </div>
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h2>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}